export const environment = {
  production: true,
  apiUrl: 'https://napet.com.sa',
  url: 'https://napet.com.sa',
  gtmId: '',  // Default empty value
  sentryDsn: '',  // Default empty value
  WEB3FORMS_KEY: '607aa4a1-1f6e-46b0-94da-d66bced6e813',
  // add other production environment settings here
};
